import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MfaErrors, MfaState } from './mfa.state';
import { TwoFactorTypes } from '../../models/user-profile.model';

const getMfaFeatureState = createFeatureSelector<MfaState>('mfa');

export const selectMfaIsLoading = createSelector(
  getMfaFeatureState,
  (state) => state.isLoading,
);

export const selectMfaHasFailed = createSelector(
  getMfaFeatureState,
  (state) => state.hasFailed,
);

export const selectMfaErrorType = createSelector(getMfaFeatureState, (state) =>
  state.errorType ? state.errorType : MfaErrors.DEFAULT,
);

export const selectMfaOriginUserProfileData = createSelector(
  getMfaFeatureState,
  (state) => state.originProduct,
);

export const selectMfaOriginUrl = createSelector(getMfaFeatureState, (state) =>
  state.originProduct?.code === 'UP' ? null : state.originProduct?.loginUrl,
);

export const selectMfaOriginEmail = createSelector(
  getMfaFeatureState,
  (state) => state.originProduct?.email,
);

export const selectMfaAnonymizedEmail = createSelector(
  getMfaFeatureState,
  (state) => {
    const email = state.originProduct?.email;

    if (
      state.twoFactorType !== TwoFactorTypes.EMAIL ||
      !email ||
      !email.includes('@')
    ) {
      return null;
    }

    const [localPart, domain] = email.split('@');
    const anonymizedLocal =
      localPart.length > 1
        ? `${localPart[0]}****${localPart[localPart.length - 1]}`
        : localPart;
    const domainParts = domain.split('.');
    const anonymizedDomain =
      domainParts.length > 1
        ? `${domainParts[0][0]}*****${
            domainParts[0][domainParts[0].length - 1]
          }.${domainParts.slice(1).join('.')}`
        : domain;

    return `${anonymizedLocal}@${anonymizedDomain}`;
  },
);
